import {Component, inject, input} from '@angular/core';
import {ButtonModule} from 'primeng/button';
import {Theme} from '../../models/game-data.model';
import {GameStore} from '../../store/game.store';
import {ResourcesService} from '../../services/resources.service';

@Component({
  selector: 'gis-theme-card',
  imports: [ButtonModule],
  templateUrl: './theme-card.component.html',
  styleUrl: './theme-card.component.scss'
})
export class ThemeCardComponent {
  protected readonly store = inject(GameStore);
  protected readonly resourcesService = inject(ResourcesService);

  readonly theme = input.required<Theme>();
}
